module.exports = __webpack_public_path__ + "static/banner-70f673645baf7aadb7e2b8b94f27af73.jpg";